import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CONSENT_KEY = "somisomi-cookie-consent";
const CHANNELIO_PLUGIN_KEY = "a0efaddd-c965-48b9-b864-2797ba4cf529";

const bootChannelIO = () => {
  const w = window;
  if (w.ChannelIOInitialized) {
    return;
  }

  const ch = function () {
    ch.c(arguments);
  };
  ch.q = [];
  ch.c = function (args) {
    ch.q.push(args);
  };
  w.ChannelIO = ch;
  w.ChannelIOInitialized = true;

  const s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
  const x = document.getElementsByTagName("script")[0];
  if (x.parentNode) {
    x.parentNode.insertBefore(s, x);
  }

  w.ChannelIO("boot", {
    pluginKey: CHANNELIO_PLUGIN_KEY,
  });
};

const CookieAgreementModal = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(CONSENT_KEY) === "accepted") {
      bootChannelIO();
    } else {
      setIsVisible(true);
    }
  }, []);

  useEffect(() => {
    let timeout;
    const handleScroll = () => {
      setIsScrolled(true);
      clearTimeout(timeout);
      timeout = setTimeout(() => setIsScrolled(false), 150);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeout);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    bootChannelIO();
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, "rejected");
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="fixed font-montserrat"
      style={{ bottom: "1rem", right: "1rem", zIndex: 1000 }}
    >
      <div
        className="bg-white text-grey_3 rounded-2xl border-2 border-purple_2 p-5 flex flex-col items-center text-center"
        style={{ width: "16rem", maxWidth: "85vw", gap: "1rem", boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)", opacity: isScrolled ? 0.6 : 1, transition: "opacity 0.3s ease" }}
      >
        <p className="text-xs leading-relaxed">
          We value your privacy and never use cookies for tracking purposes. We
          only use essential cookies to power our{" "}
          <span className="text-purple_1 font-semibold">accessibility widget</span>{" "}
          (which is enabled by default), and non-essential cookies to run our{" "}
          <span className="text-purple_1 font-semibold">customer support chat</span>{" "}
          for your convenience. You can accept all cookies or opt out of
          non-essential cookie usage. See our{" "}
          <span
            className="underline text-purple_1 cursor-pointer hover:text-purple_2"
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>
          .
        </p>

        <div className="flex flex-col w-full" style={{ gap: "0.5rem" }}>
          <button
            onClick={handleAccept}
            type="button"
            className="bg-purple_1 text-white font-semibold rounded-full focus:outline-none hover:bg-purple_2 hover:text-purple_1 transition-colors w-full"
            style={{ padding: "0.625rem 1.5rem", fontSize: "0.75rem" }}
          >
            Accept All
          </button>
          <button
            onClick={handleReject}
            type="button"
            className="bg-transparent text-purple_1 font-semibold rounded-full focus:outline-none hover:bg-purple_3 transition-colors w-full"
            style={{ padding: "0.625rem 1.5rem", fontSize: "0.75rem" }}
          >
            Reject Non-Essential
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieAgreementModal;
